// Generated file : do not modify
export enum EmploiAbattementTypes
{
  NONE = 0,
  DEGRESSIF_20,
  DEGRESSIF_25,
  FIXE
};

import { ListFilter } from '@/extend/classes/ListData';
import Contrat from '@/extend/classes/Contrat';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Emplois
export default class Emploi  {
  // Identifiant unique
  public id: number;
  // code
  public code: string;
  // Libellé
  public nom: string;
  // Code INSEE
  public codeInsee: string;
  // Code PCS
  public codePcs: string;
  // Artiste
  public artiste: boolean;
  // Cadre
  public cadre: boolean;
  // Réalisateur
  public realisateur: boolean;
  // Type d'abattement
  public abattementType: EmploiAbattementTypes;
  // Date de début de validité
  public dateDebut: Date | null;
  // Date de fin de validité
  public dateFin: Date | null;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.nom = '';
    this.codeInsee = '';
    this.codePcs = '';
    this.artiste = false;
    this.cadre = false;
    this.realisateur = false;
    this.abattementType = EmploiAbattementTypes.NONE;
    this.dateDebut = null;
    this.dateFin = null;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Emploi): Emploi {
    const newEmploi: Emploi = new Emploi();
    newEmploi.id = obj.id;
    newEmploi.code = obj.code;
    newEmploi.nom = obj.nom;
    newEmploi.codeInsee = obj.codeInsee;
    newEmploi.codePcs = obj.codePcs;
    newEmploi.artiste = obj.artiste;
    newEmploi.cadre = obj.cadre;
    newEmploi.realisateur = obj.realisateur;
    newEmploi.abattementType = obj.abattementType;
    newEmploi.dateDebut = obj.dateDebut ? new Date(obj.dateDebut) : null;
    newEmploi.dateFin = obj.dateFin ? new Date(obj.dateFin) : null;
    newEmploi.canUpdate = obj.canUpdate;
    newEmploi.canDelete = obj.canDelete;
    newEmploi.display = obj.display;
    newEmploi.notifDefType = obj.notifDefType;
    return newEmploi;
  }

  public toJsonEmploi (): string {
    const json = {
      code: this.code,
      nom: this.nom,
      codeInsee: this.codeInsee,
      codePcs: this.codePcs,
      artiste: this.artiste,
      cadre: this.cadre,
      realisateur: this.realisateur,
      abattementType: this.abattementType,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      dateFin: this.dateFin ? new Date (this.dateFin).toString() : this.dateFin,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromEmploi (obj: Emploi): void {
    this.id = obj.id;
    this.code = obj.code;
    this.nom = obj.nom;
    this.codeInsee = obj.codeInsee;
    this.codePcs = obj.codePcs;
    this.artiste = obj.artiste;
    this.cadre = obj.cadre;
    this.realisateur = obj.realisateur;
    this.abattementType = obj.abattementType;
    this.dateDebut = obj.dateDebut;
    this.dateFin = obj.dateFin;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareEmploi (value: Emploi): boolean {
    return (this.toJsonEmploi() == value.toJsonEmploi());
  }

  public cloneEmploi (): Emploi {
    return Emploi.fromJson(this);
  }

  public create (): Promise<Emploi> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/emplois/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromEmploi(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<Emploi> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/emplois/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromEmploi(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/emplois/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/emplois/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static IdccEmploi (contrat: Contrat): Promise<Emploi[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/emplois/IdccEmploi', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Emploi[] = [];
              res.data.forEach(( a: Emploi ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(emplois: Emploi[]) {
    emplois.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.dateFin = item.dateFin ? new Date(item.dateFin) : item.dateFin;
    })
  }
}
